const DEFAULT_ERROR_MESSAGE = 'Sistema indisponível. Por favor, tente novamente mais tarde.';

export class RequestStatus {
    loading: boolean;
    error: boolean;

    private errorMessage: string;

    get isLoading(): boolean {
        return this.loading && !this.error;
    }

    get isError(): boolean {
        return this.error && !this.loading;
    }

    get isNone(): boolean {
        return !this.isLoading && !this.isError;
    }

    public setErrorMessage(errorMessage: string) {
        if (typeof errorMessage === 'string') {
            this.errorMessage = errorMessage;
        } else {
            this.errorMessage = DEFAULT_ERROR_MESSAGE;
        }
    }

    public getErrorMessage(): string {
        return this.errorMessage;
    }

    public resetValues(): void {
        this.loading = false;
        this.error = false;
        this.errorMessage = '';
    }
}